import { axiosIntance } from '../../../config/ApiConfig';

export const FoodCategoriesRepository = {
  delete: (data: any) => {
    return axiosIntance.delete(`/foodCategories`, { data: { id: data._id, ...data } });
  },
  create: (form: object) => {
    return axiosIntance.post(`/foodCategories`, form);
  },
  update: (form: object) => {
    return axiosIntance.put(`/foodCategories`, form);
  }
};
